import { render, staticRenderFns } from "./EventCardGeneral.vue?vue&type=template&id=1e0b0f73&scoped=true"
import script from "./EventCardGeneral.vue?vue&type=script&lang=js"
export * from "./EventCardGeneral.vue?vue&type=script&lang=js"
import style0 from "./EventCardGeneral.vue?vue&type=style&index=0&id=1e0b0f73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0b0f73",
  null
  
)

export default component.exports